module.exports = {
      id: "edit-trainings-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "assets/img/sprite-6589e8.svg#edit-trainings-usage",
      toString: function () {
        return this.url;
      }
    }